import React from 'react';
import { ArrowRight, Plane } from 'lucide-react';
import { Button } from '../ui/button';

const ReturnTransferCard = ({ onBookReturn, pickup, dropoff }) => {
  return (
    <div className="bg-gradient-to-br from-[#FF8C00]/10 to-[#FF8C00]/5 rounded-xl p-6 border border-[#FF8C00]/20" data-testid="return-transfer-card">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-[#FF8C00] rounded-xl flex items-center justify-center flex-shrink-0">
          <Plane className="h-6 w-6 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-white text-lg mb-1">
            Need a return transfer?
          </h3>
          <p className="text-sm text-gray-300 mb-4">
            Most travelers book their return now to lock the same service quality.
          </p>

          {/* Suggested Route */}
          <div className="bg-white/10 rounded-lg p-3 mb-4">
            <p className="text-xs text-gray-400 mb-1">Suggested return route</p>
            <p className="text-sm font-medium text-white">
              {dropoff} → {pickup}
            </p>
          </div>

          <Button
            onClick={onBookReturn}
            className="bg-[#FF8C00] hover:bg-[#E67E00] text-white"
            data-testid="book-return-btn"
          >
            Book Return Transfer
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReturnTransferCard;
